<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("hardwareLocations") }}</div>
        <div class="section-subTitle my-2">{{ $t("hardwareLocations_dash") }}</div>
      </div>
      <div>
        <b-button variant="default" to="add-hardware-location" class="btn-blue">{{
          $tc("add")
        }}</b-button>
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="row w-50 ml-1">
        <b-form-input
          class="col-4"
          v-debounce:300="getHardwareLocations"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
        <div class="col-5">
          <div class="dropdown-curve-container">
            <label
              :class="
               selectedCinema
                  ? 'shift-up'
                  : ''
              "
              style="font-weight: 600"
              >{{ $tc("cinema", 1) }}</label
            >
            <multiselect
              :options="cinemas"
              v-model="selectedCinema"
              :searchable="true"
              label="cine_name"
              track-by="cine_id"
              placeholder=""
             @select="onSelectCinema($event, 'select')"
              @remove="onSelectCinema($event, 'remove')"
            ></multiselect>
          </div>
        </div>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
          <FilterByStatusDropdown
          :onSelect="
            filterIsActive => {
              this.selectedStatus = filterIsActive;
              this.getHardwareLocations();
            }
          "
        />
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>

        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-if="HardwaresLocations.length > 0"
        v-for="(item, key) in HardwaresLocations"
        :key="key"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ item.location_name }}</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  @click="goToRoute('/master/edit-hardware-location', item)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1"></div>
            <div class="d-flex align-items-end">
              <StatusDot :status="item.hl_is_active == 'Y' ? 'active' : 'inactive'" />
            </div>
          </div>
        </div>
      </div>
      <div v-if="HardwaresLocations.length == 0">
        <p>{{ $t("NoRecords") }}</p>
      </div>
    </div>

    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th>
            <img
              v-if="this.columnName != 'location_name'"
              @click="onSortValue('location_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('location_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('location_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $t("hardwareLocations") }}
          </th>
          <th class="pl-1">Cinema</th>
          <th class="text-right">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>
        </tr>
      </thead>
      <tbody v-if="HardwaresLocations.length > 0">
        <tr v-for="(item, key) in HardwaresLocations" :key="key">
          <td>{{ item.location_name }}</td>
          <td>{{ item.cine_name || '-' }}</td>
          <td>
            <div class="d-flex align-items-center justify-content-end">
              <StatusDot :status="item.hl_is_active == 'Y' ? 'active' : 'inactive'" />

              <b-dropdown right variant="edit" class="ml-4">
                <b-dropdown-item
                  @click="goToRoute('/master/edit-hardware-location', item)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody v-if="HardwaresLocations.length == 0">
        <tr>
          <td colspan="2">
            <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div>
          </td>
        </tr>
      </tbody>
    </table>
    <b-pagination
      v-if="HardwaresLocations.length > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Hardwares from "@/helper/formJSONMaster/Hardwares";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
export default {
  components: {
    StatusDot,
    FilterByStatusDropdown
  },
  data() {
    return {
      cinemas:[],
      selectedCinema: "",
      cinema_id: null,

      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      selectedStatus: 'Y',

      gridView: false,
      listView: true,
      HardwaresLocations: [],
      viewingnumbers: [],
      customErrors: {
        message: ""
      },
      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",

      debounce: null,
      searchValue: "",
      searchKey: "location_name"
    };
  },
  beforeMount() {
    this.getHardwareLocations();
    this.getviewingnumber();
    this.getCinemaList();
  },
  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ];
    },
    onSelectCinema(event, type) {
      if(type == 'remove') {
        this.cinema_id = null;
        this.selectedCinema = ''
      } else {
         this.cinema_id = event.cine_id;
        this.selectedCinema = event
      }
      this.getHardwareLocations();
    },
    getCinemaList: function (cine_id) {
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.cinemas = data.Records;
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch((error) => {
          console.log("show error2 :", error);
        });
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function(event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getHardwareLocations();
      } else {
        this.currentPage = event;
        this.getHardwareLocations();
      }
    },
    goToRoute: function(path, item) {
      console.log("item :", item);
      const { hl_id } = item;
      this.$router.push({
        path: path,
        query: {
          hl_id: hl_id
        }
      });
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getHardwareLocations();
    },
    getHardwareLocations: function() {
      this.HardwaresLocations = [];
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        searchKey: this.searchKey,
        searchValue: this.searchValue,
        orderBy: this.orderby,
        columnName: this.columnName,
        status: this.selectedStatus,
        cinema_id: this.cinema_id
      };
      MasterService.GetAllHardwareLocations(payload)
        .then(response => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.HardwaresLocations = data.Records;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.customErrors.message = data.message;
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },

    viewType: function(viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/HardwareComponents/HardwareLocations.vue